// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"5314770d67f4a69d","735":"4be63a2b82bd420c","878":"99f66efcfdea878f","935":"f1019628417a5ee0"}[chunkId] + ".js";
};